import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChildren
} from '@angular/core';
import { SalesLegalText, SalesLegalTextType } from '@ui/shared/model';

@Component({
  selector: 'app-sales-legal-checkboxes-preview',
  templateUrl: './sales-legal-checkboxes-preview.component.html',
  styleUrls: ['./sales-legal-checkboxes-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SalesLegalCheckboxesPreviewComponent {
  readonly checkboxInputs =
    viewChildren<ElementRef<HTMLInputElement>>('checkbox');
  readonly salesLegalTexts = input<SalesLegalText[]>(undefined);
  readonly previewOnly = input<boolean>(undefined);
  readonly allCheckboxesChecked = output<boolean>();
  public checkboxValue: boolean;

  public get introduction(): SalesLegalText {
    return this.salesLegalTexts().find(
      value => value.type === SalesLegalTextType.INTRODUCTION
    );
  }

  public get checkboxes(): SalesLegalText[] {
    return this.salesLegalTexts().filter(
      value => value.type === SalesLegalTextType.CHECKBOX
    );
  }

  public get conclusion(): SalesLegalText {
    return this.salesLegalTexts().find(
      value => value.type === SalesLegalTextType.CONCLUSION
    );
  }

  public checkboxValueChanged(): void {
    const anyUncheckedValue = this.checkboxInputs().some(
      input => !input.nativeElement.checked
    );

    if (!this.previewOnly()) this.allCheckboxesChecked.emit(!anyUncheckedValue);
  }
}
